import React from 'react';
import { Link } from 'react-router-dom';
import { colors } from '../lib/colors';

// Define the strategy order for next/previous navigation (kept for reference, not used for nav)
const strategyOrder = [
  {
    title: 'Buy-Sell Agreement Funding',
    slug: 'buy-sell-agreement-funding',
    category: 'business'
  },
  {
    title: 'Giant TFSA / Tax-Exempt Policies',
    slug: 'giant-tfsa-tax-exempt-policies',
    category: 'wealth'
  },
  {
    title: 'Insured Retirement Strategy',
    slug: 'insured-retirement-strategy',
    category: 'wealth'
  },
  {
    title: 'Estate Preservation',
    slug: 'estate-preservation',
    category: 'legacy' // Added category for consistency
  },
  // ... other strategies if needed for reference ...
];

// Define props for the component (even if currentSlug isn't used for prev/next, it's good practice)
interface ServicePageNavigationProps {
  currentSlug: string; // Keep prop for potential future use or context
}

// Restore the function component definition
const ServicePageNavigation: React.FC<ServicePageNavigationProps> = ({ currentSlug }) => {
  // Prev/Next logic removed as the order becomes too complex with all services.
  // Rely on "All Services" link for navigation back to the main explorer.

  return (
    <>
      {/* Back button on left */}
      <div className="absolute -top-4 left-0 z-10"> {/* Added z-index */}
        <Link
          to="/services"
          className="flex items-center text-sm hover:text-blue-600 transition-colors"
          style={{ color: colors.brand.primary }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
          </svg>
          <span>All Services</span>
        </Link>
      </div>

      {/* Removed Prev/Next Navigation */}
    </>
  );
}; // Closing brace for the function component

export default ServicePageNavigation;